export const AppSettings = Object.freeze({
    "SERVER_URL": 'https://www.pqpq.co.il/rooAppApi/api/',
    "APP_VERSION": 'https://www.pqpq.co.il/rooAppApi/app_version.php',
    "ROO_API": 'https://admin.roo.org.il/api',
    "SECURITY_KEY": '',
    "FACEBOOKID": '',
    "TOAST": {
        "duration": 3000,
        "position": "buttom"
    },
});


// WEBPACK FOOTER //
// ./src/services/app-settings.ts